export const NavigationCSS = {
    screen: {
        minHeight: "100vh",
        display: "flex",
    },
};
